import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './CompleteGuideRehab.css';

const CompleteGuideRehab = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://primerehab.ascentbw.com/Image/Logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "description": "Prime Rehab Industries is a leading manufacturer of rehabilitation equipment in Tamil Nadu, supplying 100+ clinically engineered models covering physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation to 500+ clinics and hospitals across India.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "url": "https://www.primerehabindustries.in",
          "sameAs": [
            "https://maps.app.goo.gl/placeholder"
          ],
          "areaServed": ["Tamil Nadu", "India"],
          "openingHours": "Mo-Sa 09:00-18:00"
        },
        {
          "@type": "Product",
          "name": "Chiropractic Drop Table",
          "description": "Multi-section chiropractic drop table with electric height control, adjustable drop tension, 90 mm high-density foam, and a strong stable frame for chiropractic thrust techniques. Height range 52 to 90 cm.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "112",
            "bestRating": "5",
            "worstRating": "1"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Rajesh Mohan" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "reviewBody": "The chiropractic drop table from Prime Rehab is built for serious clinical use. The drop mechanism is precise and the electric height adjustment makes it easy to work with patients of different heights. Very well engineered.",
              "datePublished": "2025-02-14"
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Lakshmi Narayanan" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "reviewBody": "We set up our entire rehabilitation department with Prime Rehab equipment. Every product is durable, well-designed, and clinically reliable. This is the guide every clinic in Tamil Nadu should read before purchasing rehab equipment.",
              "datePublished": "2025-11-30"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What are the main types of rehabilitation equipment used in physiotherapy clinics?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The main types of rehabilitation equipment used in physiotherapy clinics include treatment and therapy tables, traction tables for spinal decompression, tilting tables for postural and weight-bearing rehabilitation, Bobath tables for neurological therapy, chiropractic drop tables for spinal adjustments, and unweighing systems for gait and standing rehabilitation. Prime Rehab Industries manufactures all these categories and more."
              }
            },
            {
              "@type": "Question",
              "name": "How do I choose the right rehabilitation equipment for my clinic in Tamil Nadu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Choose rehabilitation equipment based on your therapy specialisation, patient profile, and clinic space. Prioritise equipment with adjustable height mechanisms, patient safety features like harness support and lockable wheels, and durable clinical-grade materials. Sourcing from a manufacturer like Prime Rehab Industries — rather than a generic reseller — ensures consistent quality and the option for custom sizing."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab Industries supply rehabilitation equipment for both neurological and orthopaedic conditions?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries manufactures equipment for neurological rehabilitation including the High Low Bobath Table and High Low Tilting Table, and for orthopaedic rehabilitation including traction tables, multi-section treatment tables, and the Unweighing System for post-surgery gait training. Their range covers physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation needs."
              }
            },
            {
              "@type": "Question",
              "name": "Can I get a complete rehabilitation equipment setup from Prime Rehab Industries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries offers over 100 rehabilitation equipment models, making it possible to source a complete clinic or hospital rehabilitation department setup from a single manufacturer. From treatment tables and traction equipment to gait training systems and chiropractic tables, everything is available in one place. Custom sizes are also available on request."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Complete Guide to Rehabilitation Equipment in Tamil Nadu",
              "item": "https://www.primerehabindustries.in/blog/complete-guide-rehabilitation-equipment-tamil-nadu"
            }
          ]
        }
      ]
    };

    document.title = "Rehabilitation Equipment Guide Tamil Nadu | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Your complete guide to rehabilitation equipment in Tamil Nadu. Prime Rehab Industries offers 100+ models trusted by 500+ clinics across India.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/complete-guide-rehabilitation-equipment-tamil-nadu";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="clean-guide-page">
      <Navbar />

      {/* Clean Hero Section */}
      <section className="clean-hero">
        <div className="clean-hero-container">
          <div className="clean-hero-text">
            <span className="clean-badge">Complete Guide</span>
            <h1>Rehabilitation Equipment in Tamil Nadu</h1>
            <p>
              At some point, every physiotherapy clinic faces the same question: is the equipment we have actually built for the work we do? 
            </p>
            <div className="clean-hero-actions">
              <a href="#guide-start" className="clean-btn-primary">Read the Guide</a>
            </div>
          </div>
          <div className="clean-hero-image">
            <img src="https://primerehab.ascentbw.com/Image/Product/Pro2.png" alt="Prime Rehab Industries Chiropractic Drop Table" />
          </div>
        </div>
      </section>

      {/* Intro Box */}
      <section id="guide-start" className="clean-intro">
        <div className="clean-container">
          <div className="intro-white-box">
            <h2>The Foundation of Clinic Performance</h2>
            <p className="clean-lead">
              Whether you're purchasing for the first time or reassessing what's already in your treatment rooms, that answer shapes how your clinic performs for patients, therapists, and long-term operating costs.
            </p>
            <p>
              This guide covers everything you need to know: the main categories of rehabilitation equipment, how to choose the right products for your clinic's specialisation, what to look for in a manufacturer, and where to source quality rehabilitation equipment in Tamil Nadu. Prime Rehab Industries, with 12+ years of manufacturing experience and 100+ equipment models trusted by 500+ clinics across India, is referenced throughout as an example of what good clinical rehabilitation equipment looks like in practice.
            </p>
          </div>
        </div>
      </section>

      {/* Definition Two-Column */}
      <section className="clean-definition">
        <div className="clean-container">
          <div className="definition-grid">
            <div className="def-text">
              <h2>What Is Rehabilitation Equipment?</h2>
              <p>
                Rehabilitation equipment refers to the specialised tools and furniture used by physiotherapists, chiropractors, occupational therapists, and other healthcare professionals to assess, treat, and rehabilitate patients.
              </p>
              <p>
                Unlike general hospital furniture, rehabilitation equipment is engineered for active clinical use—built to handle patient loads, therapy movements, and the daily demands of a busy clinic over many years.
              </p>
            </div>
            <div className="def-list">
              <h4>Primary Applications</h4>
              <ul>
                <li>Hospital Physiotherapy Departments</li>
                <li>Standalone Physiotherapy Clinics</li>
                <li>Sports Injury Centres</li>
                <li>Neurological Rehabilitation Units</li>
                <li>Paediatric Therapy Centres</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Main Types - Clean Cards */}
      <section className="clean-types">
        <div className="clean-container">
          <div className="section-header-clean">
            <h2>Main Types of Rehabilitation Equipment</h2>
            <div className="header-line"></div>
          </div>
          
          <div className="clean-card-grid">
            <div className="clean-card">
              <div className="card-num">01</div>
              <h3>Treatment & Therapy Tables</h3>
              <p>Treatment tables are the foundation of any clinic. Electrically height-adjustable tables, such as the High Low Two Fold Table, allow therapists to work at optimal heights without straining. Key features to look for include high density foam padding, rexine upholstery, and lockable caster wheels.</p>
            </div>

            <div className="clean-card">
              <div className="card-num">02</div>
              <h3>Spinal Decompression</h3>
              <p>Purpose-built traction equipment such as the SPINETHERA DTS Table provides a controlled, reliable traction lock system. The High Low Traction Table adds electric height control and an adjustable backrest. The reliability of the traction lock mechanism is the most important factor.</p>
            </div>

            <div className="clean-card">
              <div className="card-num">03</div>
              <h3>Neurological Rehab</h3>
              <p>Patients recovering from strokes require equipment that supports complex positioning. The High Low Bobath Table provides a wide, stable surface. The High Low Tilting Table takes this further with motorized tilt from +20° to -120° and harness support.</p>
            </div>

            <div className="clean-card">
              <div className="card-num">04</div>
              <h3>Gait Training Systems</h3>
              <p>The Unweighing System uses a motorized DC lifting mechanism and a digital hanging scale to provide precisely controlled body weight support. SS pipe walking handrails, a safety harness, and an optional treadmill attachment complete the system.</p>
            </div>

            <div className="clean-card full-span">
              <div className="card-num">05</div>
              <h3>Chiropractic Adjustment Tables</h3>
              <p>The treatment surface needs to handle the precise, controlled thrust techniques that define chiropractic adjustment. The Chiropractic Drop Table from Prime Rehab features a multi-section drop mechanism with customisable resistance, electric height control from 52 to 90 cm, and 90 mm high-density foam padding.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Light Quote */}
      <section className="clean-quote">
        <div className="clean-container">
          <div className="quote-light-box">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="var(--clean-primary)" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.017 21L16.439 14.01C16.552 13.689 16.536 13.331 16.397 13.023C16.257 12.715 16.006 12.483 15.698 12.385C14.475 11.996 13.606 10.871 13.606 9.499C13.606 7.57 15.176 6 17.106 6C18.673 6 19.98 7.042 20.44 8.5H19.5C18.672 8.5 18 9.172 18 10C18 10.828 18.672 11.5 19.5 11.5H21C21.828 11.5 22.5 10.828 22.5 10V9.499C22.5 6.467 20.038 4 17.106 4C14.173 4 11.712 6.467 11.712 9.499C11.712 11.455 12.766 13.153 14.364 14.088L12.017 21H14.017ZM5.017 21L7.439 14.01C7.552 13.689 7.536 13.331 7.397 13.023C7.257 12.715 7.006 12.483 6.698 12.385C5.475 11.996 4.606 10.871 4.606 9.499C4.606 7.57 6.176 6 8.106 6C9.673 6 10.98 7.042 11.44 8.5H10.5C9.672 8.5 9 9.172 9 10C9 10.828 9.672 11.5 10.5 11.5H12C12.828 11.5 13.5 10.828 13.5 10V9.499C13.5 6.467 11.038 4 8.106 4C5.173 4 2.712 6.467 2.712 9.499C2.712 11.455 3.766 13.153 5.364 14.088L3.017 21H5.017Z"/>
            </svg>
            <blockquote>
              The chiropractic drop table from Prime Rehab is built for serious clinical use. The drop mechanism is precise and the electric height adjustment makes it easy to work with patients of different heights. Very well engineered.
            </blockquote>
            <cite>— Dr. Rajesh Mohan, Chiropractor, Tamil Nadu</cite>
          </div>
        </div>
      </section>

      {/* Connected Line Steps for How to Choose */}
      <section className="clean-steps-section">
        <div className="clean-container">
          <div className="section-header-clean text-center">
            <h2>How to Choose Rehabilitation Equipment</h2>
            <div className="header-line center"></div>
          </div>
          
          <div className="clean-timeline">
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <h4>Match Equipment to Your Therapy Specialisation</h4>
                <p>A neurological rehabilitation centre needs Bobath tables and tilting tables. A sports physiotherapy clinic needs versatile treatment tables. Avoid buying generic products that claim to do everything.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <h4>Prioritise Adjustability and Patient Safety</h4>
                <p>Electric height adjustment protects therapists from back strain. Harness clips, lockable wheels, and safety guard rails protect patients during vulnerable stages of recovery. Do not cut costs here.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <h4>Choose a Manufacturer Over a Generic Reseller</h4>
                <p>A manufacturer like Prime Rehab Industries controls the quality of every component—frame steel, mechanism torque, foam density. A reseller often cannot. Direct support is also much faster.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <h4>Consider Custom Sizing</h4>
                <p>Standard equipment dimensions are designed for the average clinic. If you work with paediatric patients, bariatric patients, or in a compact clinic space, standard sizing may not be optimal. Ask for custom sizing.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Second Light Quote */}
      <section className="clean-quote">
        <div className="clean-container">
          <div className="quote-light-box">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="var(--clean-primary)" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.017 21L16.439 14.01C16.552 13.689 16.536 13.331 16.397 13.023C16.257 12.715 16.006 12.483 15.698 12.385C14.475 11.996 13.606 10.871 13.606 9.499C13.606 7.57 15.176 6 17.106 6C18.673 6 19.98 7.042 20.44 8.5H19.5C18.672 8.5 18 9.172 18 10C18 10.828 18.672 11.5 19.5 11.5H21C21.828 11.5 22.5 10.828 22.5 10V9.499C22.5 6.467 20.038 4 17.106 4C14.173 4 11.712 6.467 11.712 9.499C11.712 11.455 12.766 13.153 14.364 14.088L12.017 21H14.017ZM5.017 21L7.439 14.01C7.552 13.689 7.536 13.331 7.397 13.023C7.257 12.715 7.006 12.483 6.698 12.385C5.475 11.996 4.606 10.871 4.606 9.499C4.606 7.57 6.176 6 8.106 6C9.673 6 10.98 7.042 11.44 8.5H10.5C9.672 8.5 9 9.172 9 10C9 10.828 9.672 11.5 10.5 11.5H12C12.828 11.5 13.5 10.828 13.5 10V9.499C13.5 6.467 11.038 4 8.106 4C5.173 4 2.712 6.467 2.712 9.499C2.712 11.455 3.766 13.153 5.364 14.088L3.017 21H5.017Z"/>
            </svg>
            <blockquote>
              We set up our entire rehabilitation department with Prime Rehab equipment. Every product is durable, well-designed, and clinically reliable. This is the standard every clinic in Tamil Nadu should expect.
            </blockquote>
            <cite>— Dr. Lakshmi Narayanan, Rehabilitation Department Head, Chennai</cite>
          </div>
        </div>
      </section>

      {/* Clean FAQs */}
      <section className="clean-faq">
        <div className="clean-container">
          <div className="faq-wrapper">
            <h2 className="text-center">Frequently Asked Questions</h2>
            <div className="clean-faq-list">
              <div className="clean-faq-item">
                <h5>What are the main types of rehabilitation equipment used in clinics?</h5>
                <p>The main types include treatment tables, traction tables for spinal decompression, tilting tables for weight-bearing rehab, Bobath tables for neuro therapy, chiropractic drop tables, and unweighing systems.</p>
              </div>
              <div className="clean-faq-item">
                <h5>How do I choose the right rehabilitation equipment?</h5>
                <p>Choose based on your therapy specialisation, patient profile, and space. Prioritise height mechanisms, patient safety features, and durable clinical-grade materials. Sourcing from a direct manufacturer ensures consistent quality.</p>
              </div>
              <div className="clean-faq-item">
                <h5>Does Prime Rehab supply equipment for neuro and orthopaedic conditions?</h5>
                <p>Yes. They manufacture equipment for neurological rehabilitation including Bobath and Tilting Tables, and for orthopaedic rehabilitation including traction tables and Unweighing Systems for gait training.</p>
              </div>
              <div className="clean-faq-item">
                <h5>Can I get a complete equipment setup from Prime Rehab Industries?</h5>
                <p>Yes. With over 100 models, it's possible to source a complete clinic or hospital department setup from a single manufacturer. Custom sizes are also available on request.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="clean-cta">
        <div className="clean-container">
          <div className="clean-cta-box">
            <h2>Ready to Equip Your Rehabilitation Clinic?</h2>
            <p>
              Prime Rehab Industries manufactures 100+ models of clinically engineered rehabilitation equipment and supplies directly to clinics and hospitals across Tamil Nadu and India. Custom sizes available. Trusted by 500+ facilities and 1,000+ installations.
            </p>
            <div className="cta-button-group">
              <a href="/products" className="clean-btn-primary">View Products</a>
              <a href="tel:+919994351947" className="clean-btn-outline">Call +91 99943 51947</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompleteGuideRehab;
